import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthActions } from '@auth/store';
import { PicklistActions } from '@features/referentiel/actions/picklist.actions';
import { PicklistService } from '@features/referentiel/services/picklist.service';
import { Picklist, PicklistValueDetail } from '@features/referentiel/models/picklist';

@Injectable()
export class PicklistEffects {

    initPicklists$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.userProfileLoaded),
            map(() => PicklistActions.getPicklists())
        )
    );

    loadPicklists$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PicklistActions.getPicklists),
            switchMap(() =>
                this.picklistService.getAllPicklist().pipe(
                    map((data: Picklist[]) => PicklistActions.getPicklistsSuccess({ picklists: data })),
                    catchError((error) => of(PicklistActions.getPicklistsFailure({ errorMessage: error })))
                )
            )
        )
    );

    initPicklistsValueDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthActions.userProfileLoaded),
            map(() => PicklistActions.getPicklistsValueDetails())
        )
    );

    loadPicklistsValueDetails$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PicklistActions.getPicklistsValueDetails),
            switchMap(() =>
                this.picklistService.getAllEnabledPicklistsValueDetails().pipe(
                    map((data: PicklistValueDetail[]) => PicklistActions.getPicklistsValueDetailsSuccess({ picklistValueDetails: data })),
                    catchError((error) => of(PicklistActions.getPicklistsValueDetailsFailure({ errorMessage: error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private picklistService: PicklistService) { }
}